<script lang="ts">
import { defineComponent } from 'vue';
import LocaleSwitcher from './LocaleSwitcher.vue';

export default defineComponent({
  name: 'AuthHeaderActions',
  components: { LocaleSwitcher }
});
</script>

<template>
  <teleport to="header#breadcrumbs">
    <div class="breadcrumbs"></div>
    <div class="header-actions">
      <locale-switcher />
    </div>
  </teleport>
</template>
